<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-image-search-outline">{{
              $t("homeMenuAdminArchiveTitle")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-6 pa-0 pb-10" v-show="enableSearch">
            <v-card
              class="#505050--text"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-title>
                {{ $t("homeMenuAdminArchiveViewTitle") }}
                <v-btn
                  fab
                  class="elevation-0 ml-3"
                  :color="getTheme() == 'dark' ? 'primary' : 'white'"
                  small
                  @click="executeSearch"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    >mdi-magnify</v-icon
                  >
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  class="elevation-0"
                  :color="getTheme() == 'dark' ? 'primary' : 'white'"
                  small
                  @click="enableSearch = false"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    >mdi-arrow-left</v-icon
                  >
                </v-btn>
              </v-card-title>
              <v-card-text class="pb-0 mb-0">
                <v-flex xs12>
                  <v-select
                    item-text="title"
                    item-value="field"
                    :items="searchByItems"
                    v-model="searchByItem"
                    :label="$t('homeMenuAdminArchiveSearchType')"
                  ></v-select>
                  <v-text-field
                    class="mb-1"
                    v-model="searchStr"
                    :label="$t('homeMenuAdminArchiveViewSearchStrTitle')"
                    :rules="[validateMaxLength(50)]"
                    :counter="50"
                    v-on:keyup.enter="executeSearch"
                  ></v-text-field>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex v-show="!enableSearch" xs12 class="mx-1 mb-6 pa-0 pb-10">
            <v-card
              class="#505050--text"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-text class="pa-1 my-0">
                <div class="d-flex align-center flex-wrap pa-0 ma-0 mt-1 ml-1">
                  <div
                    class="ma-0 pa-0 mr-1"
                    style="height: 45px; width: 185px"
                  >
                    <v-select
                      :label="$t('userOrdersDisplayList')"
                      outlined
                      dense
                      class="ma-0 pa-0"
                      item-text="title"
                      item-value="days"
                      :items="toggleFilterItems"
                      v-model="$store.state.storeOrders.viewDate"
                      @change="setNewViewDate"
                    ></v-select>
                  </div>
                  <div class="ma-0 pa-0 mt-1 pb-2 pl-2">
                    <v-icon color="black" small>mdi-circle-slice-8</v-icon>
                    <span class="hidden-xs-only pl-1">
                      {{ $t("userOrdersStatus3Title") }}
                    </span>
                  </div>
                  <v-spacer></v-spacer>
                  <div style="height: 40px">
                    <v-btn
                      text
                      outlined
                      class="elevation-0 mr-1"
                      medium
                      @click="enableSearch = true"
                    >
                      <v-icon
                        :class="
                          getTheme() == 'dark' ? 'primary--text' : 'white--text'
                        "
                        >mdi-magnify</v-icon
                      >
                      {{ $t("userOrdersNewSearchList") }}
                    </v-btn>
                    <v-btn
                      text
                      outlined
                      class="elevation-0 mr-1"
                      medium
                      @click="removeFilter"
                    >
                      <v-icon
                        :class="
                          getTheme() == 'dark' ? 'primary--text' : 'white--text'
                        "
                        >mdi-filter-remove</v-icon
                      >
                    </v-btn>
                  </div>
                </div>
                <v-progress-linear
                  v-show="loading"
                  indeterminate
                  color="primary"
                ></v-progress-linear>

                <!-- iskanje nima zapisov -->
                <div
                  v-if="$store.state.storeOrders.archive.length == 0"
                  class="ma-2"
                >
                  <div class="d-flex">
                    <v-spacer></v-spacer>
                    <v-icon small>mdi-emoticon-sad-outline</v-icon>
                    <span class="ml-2 subtitle-2">
                      {{ $t("homeMenuAdminArchiveSearchNoResults") }}
                    </span>
                    <v-spacer></v-spacer>
                  </div>
                </div>

                <div
                  style="background-color: #fcfcfc; border: 1px solid gainsboro"
                  class="ma-0"
                >
                  <v-expansion-panels accordion>
                    <v-expansion-panel
                      v-for="item in $store.state.storeOrders.archive"
                      :key="item.id"
                    >
                      <v-expansion-panel-header
                        style="background-color: #f2f2f2"
                        class="pa-3 pb-2"
                      >
                        <!-- EXPORT PDF HIDDEN CONTENT -->
                        <div v-show="false">
                          <div :id="'exportPdf-' + item.orderId">
                            <export-order-info :item="item"></export-order-info>
                          </div>
                        </div>

                        <div
                          class="
                            d-flex
                            align-center
                            justify-middle
                            flex-wrap
                            pa-0
                            ma-0
                          "
                        >
                          <!-- export pdf button -->
                          <div class="mb-1">
                            <v-icon
                              medium
                              @click="exportOrderToPdf(item.orderId)"
                              @click.stop
                              class="secondary--text hover-item mr-2"
                              >mdi-file-export</v-icon
                            >
                          </div>

                          <div
                            class="d-flex align-center flex-wrap pa-0 ma-0 pr-1"
                          >
                            <div
                              v-for="(item2, index2) in item.storeCart.cart"
                              :key="index2"
                            >
                              <v-icon
                                v-if="item2.module == G_MODULE_PHOTO_ORDER"
                                small
                                :color="
                                  item2.done || item.status > 1
                                    ? 'success'
                                    : 'gray'
                                "
                                class="mr-1 mb-1"
                                >mdi-image-multiple</v-icon
                              >
                              <span
                                v-else-if="item2.module == G_MODULE_PHOTO_GIFT"
                              >
                                <span v-if="item2.superType !== undefined">
                                  <v-icon
                                    v-if="item2.superType == 0"
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-package-variant</v-icon
                                  >
                                  <v-icon
                                    v-else-if="item2.superType == 1"
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-glass-mug</v-icon
                                  >
                                  <v-icon
                                    v-else-if="item2.superType == 2"
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-collage</v-icon
                                  >
                                  <v-icon
                                    v-else-if="item2.superType == 3"
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-picture-in-picture-bottom-right</v-icon
                                  >
                                  <v-icon
                                    v-else-if="item2.superType == 4"
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-wallet-giftcard</v-icon
                                  >
                                  <v-icon
                                    v-else-if="item2.superType == 5"
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-resize</v-icon
                                  >
                                  <v-icon
                                    v-else-if="item2.superType == 6"
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-palette</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon
                                    small
                                    :color="
                                      item2.done || item.status > 1
                                        ? 'success'
                                        : 'gray'
                                    "
                                    class="mr-1 mb-1"
                                    >mdi-glass-mug</v-icon
                                  >
                                </span>
                              </span>
                            </div>
                          </div>

                          <div class="mb-1 mr-2">
                            <v-icon small color="primary" class="mr-2"
                              >mdi-barcode-scan</v-icon
                            >
                            <strong>{{ item.orderId }}</strong>
                            ({{ item.fullName }})
                          </div>
                          <div class="mb-1 mr-2">
                            <v-icon small color="primary" class="mr-1"
                              >mdi-alarm-plus</v-icon
                            >
                            {{ getMoment(item.timestamp.seconds) }} ({{
                              getMomentDay(item.timestamp.seconds)
                            }})
                          </div>
                          <div class="mb-1 mr-2">
                            <v-icon small color="primary" class="mr-1"
                              >mdi-walk</v-icon
                            >
                            {{ item.deliveryName }}
                          </div>
                          <div class="mb-1 mr-2">
                            <v-icon small color="primary" class="mr-1 mb-1"
                              >mdi-account-cash</v-icon
                            >
                            {{ item.deliveryTypeString }}
                          </div>
                          <div class="mr-2">
                            <v-icon small color="primary" class="mr-2 mb-1"
                              >mdi-cash-multiple</v-icon
                            >
                            <strong>{{ price(item.deliveryFinalSum) }}</strong>
                          </div>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="pa-0 pb-4 ma-0">
                        <display-order-info
                          mode="archive"
                          :item="item"
                          :stats="true"
                        ></display-order-info>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <simple-navigation-button
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            left
            @clicked="$router.push({ name: 'homeMenuAdminPackages' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import ExportOrderInfo from "@/components/orderInfo/ExportOrderInfo";
import DisplayOrderInfo from "@/components/orderInfo/DisplayOrderInfo";
import { G_MODULE_PHOTO_ORDER } from "@/constants";
import { G_MODULE_PHOTO_GIFT } from "@/constants";
import { G_MODULE_ALL } from "@/constants";
import html2pdf from "html2pdf.js";
import moment from "moment";

export default {
  name: "homeMenuAdminPackages",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
    ExportOrderInfo,
    DisplayOrderInfo,
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      loading: false,
      enableSearch: false,
      searchStr: "",
      searchByItem: "orderId",
      searchByItems: [
        {
          title: this.$t("homeMenuAdminArchiveSearchByOrderId"),
          field: "orderId",
        },
        {
          title: this.$t("homeMenuAdminArchiveSearchByEmail"),
          field: "email",
        },
      ],
    };
  },
  methods: {
    exportOrderToPdf(orderId) {
      let element = document.getElementById("exportPdf-" + orderId);
      let opt = {
        filename: orderId + ".pdf",
        image: { type: "jpeg", quality: 0.9 },
        html2canvas: { scale: 2, scrollX: 0, scrollY: 0 },
        jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
      };

      // New Promise-based usage:
      html2pdf().from(element).set(opt).save();
    },
    getMoment(item) {
      return moment.unix(item).format("DD.MM.YY HH:mm");
    },
    getMomentDay(item) {
      switch (moment.unix(item).day()) {
        case 0:
          return this.$t("dayMonday");
        case 1:
          return this.$t("dayTuesday");
        case 2:
          return this.$t("dayWednesday");
        case 3:
          return this.$t("dayThursday");
        case 4:
          return this.$t("dayFriday");
        case 5:
          return this.$t("daySaturday");
        case 6:
          return this.$t("daySunday");
        default:
          return "";
      }
    },
    executeSearch() {
      this.$store
        .dispatch("getArchiveItems", {
          client: this.$store.state.storeClient.client.basicSettings.name,
          str: this.searchStr,
          field: this.searchByItem,
          days: 7,
        })
        .then(() => {
          this.loading = false;
          this.enableSearch = false;
        });
    },
    async setNewViewDate() {
      this.loading = true;
      try {
        await this.$store
          .dispatch("getArchiveItems", {
            client: this.$store.state.storeClient.client.basicSettings.name,
            field: "all",
            days: this.$store.state.storeOrders.viewDate,
          })
          .then(() => {
            this.loading = false;
          });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    removeFilter() {
      this.$store
        .dispatch("getArchiveItems", {
          client: this.$store.state.storeClient.client.basicSettings.name,
          field: "all",
          days: 7,
        })
        .then(() => {
          this.loading = false;
          this.enableSearch = false;
        });
    },
  },
  beforeUpdate() {
    //console.log(">>> BEFORE UPDATE forceUpdate");
    this.$forceUpdate(); // update za dodano pred xx min
  },
  created() {
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
    this.G_MODULE_ALL = G_MODULE_ALL;
  },
  mounted() {
    this.removeFilter();
  },
};
</script>
<style>
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel-content__wrap {
  padding: 0;
  margin: 0;
}
</style>
